import { create } from 'zustand';

import type { Session } from '@/lib/permissions';

/*
 * Derived session store (spec §3.2, §3.6). Holds what the server does not: the
 * resolved session object guards read imperatively via getState() outside
 * React. The raw /me response lives in the query cache; this is the derived
 * projection used by beforeLoad guards, the shell, and permissions.
 */
interface AuthState {
  session: Session | null;
  setSession: (session: Session | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
  clear: () => set({ session: null }),
}));
